import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  viewAllLink?: string;
}

export default function MovieSection({ title, subtitle, movies, viewAllLink }: MovieSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-5 md:mb-6">
          <div>
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-100">
              {title}
            </h3>
            {subtitle && (
              <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-3 md:gap-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} variant="poster" />
          ))}
        </div>
      </div>
    </section>
  );
}